import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import videoCover from "../../../../../../../media/images/videoCover.png";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../../media/images/icons/arrow-left";
import KarenCoin from "../../../../../../../media/images/icons/karenCoin.svg";

export default function VideoCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 2,
        width: "100%",
        // border: "1px solid gray",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid
        sx={{
          alignItems: "center",
        }}
        container
        spacing={1}
      >
        <Grid item xs={3}>
          <Box
            sx={{
              paddingRight: "16px",
              // height: "100px",
              // border: "1px solid gray",
              display: "flex",
              gap: "4px",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                }}
              >
                01
              </Typography>
              <hr
                style={{
                  width: "100%",
                }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              راننده جدید در بازارگاه
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                // border: "1px solid gray",
                gap: "4px",
                paddingX: "8px",
                borderRadius: "20px",
                width: "fit-content",
                backgroundColor: "#424242",
              }}
            >
              <img src={KarenCoin} alt="" />
              <Typography color={"#FFD54F"}>475</Typography>
            </Box>
            <Box
              sx={{
                backgroundColor: "secondary.light",
                width: "fit-content",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "secondary.main",
                }}
              >
                درحال مشاهده
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Box
            sx={{
              overflow: "hidden",
              borderRadius: "16px",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
              position: "relative",
              height: "150px",
              // border: "1px solid gray",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={videoCover}
              alt=""
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                paddingX: "16px",
                paddingY: "8px",
                width: "100%",
                backgroundColor: "#fff",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "11px",
                  mb: 2,
                  fontWeight: "600",
                }}
              >
                آموزش دریافت بار و شرکت در مناقصه که اگر متن طولانی
              </Typography>
              <Link
                to={"#"}
                style={{
                  borderRadius: "4px",
                  justifyContent: "center",
                  backgroundColor: theme.palette.secondary.main,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    paddingY: "4px",
                    fontSize: "12px",
                    color: "#fff",
                  }}
                >
                  مشاهده آموزش‌ها
                </Typography>
                <ArrowLeftSVG />
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
